import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import * as actions from '../store/options.actions'

export function* setImmobilizationAssessmentOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getAssessmentOptions])
    const { entity } = response
    yield put(actions.setImmobilizationAssessmentOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setImmobilizationAssessmentOptions() error: ${e}`))
  }
}
export function* setImmobilizationAssessmentOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setImmobilizationAssessmentOptions)
}
